module.exports = __webpack_public_path__ + "img/CPM.3a96879a.png";